import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import DropdownBox from '../../components/Dropdown/DropdownBox/DropdownBox';
import Option from '../../components/Dropdown/DropdownOption/DropdownOption';

export const ListItemDropdownKey = Symbol('ListItemDropdown');

const m = defineMessages({
  stationDetails: {
    id: 't.stationDetails',
    defaultMessage: 'Station Details',
  },
  share: {
    id: 't.share',
    defaultMessage: 'Share',
  },
  delete: {
    id: 't.delete',
    defaultMessage: 'Delete',
  },
});

class ListItemDropdown extends React.Component {
  static propTypes = {
    childProps: PropTypes.shape({
      onShare: PropTypes.func,
      onStationDetails: PropTypes.func,
      onDelete: PropTypes.func,
    }),
    dropdownType: PropTypes.any,
    closeDropdown: PropTypes.func,
    intl: PropTypes.object,
  };

  render() {
    const t = this.props.intl.formatMessage;
    const settings = [];
    if (this.props.childProps.onStationDetails) {
      settings.push({
        label: t(m.stationDetails),
        callback: this.props.childProps.onStationDetails,
      });
    }
    if (this.props.childProps.onShare) {
      settings.push({
        label: t(m.share),
        callback: this.props.childProps.onShare,
      });
    }
    if (this.props.childProps.onDelete) {
      settings.push({
        label: t(m.delete),
        callback: this.props.childProps.onDelete,
        extrasStyles: ['DropdownOption__red'],
      });
    }
    const options = settings.map(({ label, callback, extrasStyles }, i) => {
      const optionProps = {
        callback,
        label,
        key: `option${i}`,
        closeDropdown: this.props.closeDropdown,
        extrasStyles,
      };

      return <Option key={i} {...optionProps} />;
    });
    return <DropdownBox menuType={this.props.dropdownType}>{options}</DropdownBox>;
  }
}

export const constructors = {
  [ListItemDropdownKey]: injectIntl(ListItemDropdown),
};
